import { GQL_QUERIES } from 'src/utils/analytics/newrelic/ErrorTracker';

import { getLocalStorage } from '../../utils/browserStorageHandler';
import { GUEST_TOKEN } from '../../utils/constants/localStorageConstants';
import { DEVICE_MANAGEMENT_REMOVEDEVICE_QUERY } from '../GraphQL/Queries/DeviceManagementQueries';
import { graphQlRequest } from '../GraphQL/RequestHandler';

export const removeCurrentUserDevice = async () => {
  try {
    const device_id = getLocalStorage(GUEST_TOKEN);
    const requestParams = {
      deviceIds: [device_id]
    };
    if (device_id) {
      await graphQlRequest(
        DEVICE_MANAGEMENT_REMOVEDEVICE_QUERY,
        requestParams,
        GQL_QUERIES.DEVICE_MANAGEMENT_QUERY
      );
    }
  } catch (error) {
    console.error('Error on logout Device: ', error);
    return {};
  }
};
